import { has } from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  configList: [],
  analysisResult: null,
  fileConfirmedOk: false,
  importStatus: {
    queued: false,
    queuing: false,
    error: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.DC_IMPORT_SAVE_CONFIG_LIST:
      return { ...state, configList: payload };

    case types.DC_SET_ANALYSIS_RESULT:
      return {
        ...state,
        analysisResult: payload,
      };

    case types.DC_SET_FILE_CONFIRMED_OK:
      return {
        ...state,
        fileConfirmedOk: payload,
      };

    case types.DC_IMPORT_SUBMITTING:
      return {
        ...state,
        importStatus: {
          ...state.importStatus,
          queuing: payload,
          queued: false,
        },
      };

    case types.DC_IMPORT_QUEUE_ERROR: {
      let error;

      if (has(payload, 'response.data.Errors')) {
        error = payload.response.data.Errors[0];
      } else {
        error = {
          Title: 'Error',
          Message:
            'An error occurred while queuing this Import. Please try again.',
        };
      }

      return {
        ...state,
        importStatus: {
          ...state.importStatus,
          error,
          queued: false,
        },
      };
    }

    case types.DC_IMPORT_CLEAR_QUEUE_ERROR:
      return {
        ...state,
        importStatus: {
          ...state.importStatus,
          error: null,
        },
      };

    case types.DC_IMPORT_QUEUE_SUCCESS:
      return {
        ...state,
        importStatus: {
          ...state.importStatus,
          queued: true,
        },
      };

    case types.DC_IMPORT_SAVE_UNMATCHED_COUNT:
      return { ...state, unmatchedCount: payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/dcimport/state/hub/reducer.js